import RouterPage from './pages/RouterPage';
import * as React from 'react'
import { ThemeProvider } from 'styled-components';

// Dashboard SCSS imports MUST be eager (entry-bundle) — not in the lazy
// dashboard chunk. Reason: dashlite.scss declares @font-face for Nioicon
// (the dashboard icon font) and Nunito. When the SCSS lives in a lazy
// chunk under /static/css/[chunk-hash].css, webpack rewrites the
// font url() paths relative to that chunk file. Browsers don't always
// resolve those rewritten paths correctly when the chunk loads after
// initial page render — icons render as empty boxes and fonts fall
// back. Eagerly importing here puts the @font-face declarations in
// main.css with stable URLs that always resolve.
//
// Cost: ~58KB of dashboard CSS ships on landing pages. Worth it — the
// 12MB → ~3MB JS bundle win still stands; this is just CSS.
import './Dashboard/assets/scss/dashlite.scss';
import './Dashboard/assets/scss/style-email.scss';
global.purchaseAmount = 0
global.advancedAnalytics = {}
function rtl() {
  return (
    <div></div>
  )
}
function topMenu() {
  return (
    <div />
  )
}
const darkMode = false;

const VIKTOR_IP = 'http://172.17.64.1'
const MASA_IP = 'http://192.168.0.55'
const SERVER = 'https://textlinksms.com'
const VIKTOR_HN = 'http://192.168.1.20'
const VIKTOR_FON = 'http://172.20.10.5'
const VIKTOR_2 = 'http://192.168.0.237'
const IP_YETTEL_SMRDI = 'http://10.183.166.191'
global.SERVIP = SERVER // 'http://127.0.0.1' // 
function App() {
  return (
    <RouterPage />
  );
}

export default App;
